<template>
  <header>
    <!--v-app-bar
      app
      flat
      dense
      clipped-left
      class="toolbar-titlew"
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-show="!isDesconto"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Cobrança</span>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>

    </v-app-bar-->
    

    <v-navigation-drawer 
      v-model="drawer" 
      v-if="isLoggin" 
      v-show="!isDesconto" 
      clipped 
      width="200"
      app>
      <v-list dense>
        
        <v-list-item>
          <v-list-item-title style="font-size: 20px;margin: 10px;">
            <!-- Cobrança -->
            <img :src="empresa&&empresa.images?empresa.images[0].image:'static/img/logo.png'" v-if="isLoggin" alt="Cobrança" height="60px" width="150px">
    
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title style="font-size: 20px;">
            <v-text-field 
                  outlined
                  class="mr-2 ml-2" 
                  v-model="search" 
                  append-icon="search"
                  required></v-text-field>
          </v-list-item-title>
        </v-list-item>
        <template v-for="item in filterItems(items)">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :append-icon="item.model ? item.icon : item['icon-alt']"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" :to="{path:child.link}">
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="{path:item.link}">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="drawerRight"
      app
      right
    >
      <v-list dense>
        <v-list-item>
          <v-list-item-content style="font-size: 28px">
            <v-list-item-title>Chat Room</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item  v-for="(usuario, i) in usuarios" :key="i" :to="{path:getPath(usuario)}" >
          <v-badge
            :content="usuario.notificacao?usuario.notificacao.count:0"
            :value="usuario.notificacao?usuario.notificacao.count:0"
            color="green"
            overlap
            >
            <v-list-item-avatar style="margin-right: 2px; margin-left: 2px;">
              <img :src="usuario.name?'https://ui-avatars.com/api/?background=0D8ABC&color=fff&name='+usuario.name.replace(' ', '+')+'':''" >
            </v-list-item-avatar>
          </v-badge>
          <v-list-item-content>
            <v-list-item-title>{{usuario.name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-dialog
      v-model="dialogNotif"
      persistent 
      width="700"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Agendamento</span>
        </v-card-title>
        <v-card-text v-if="agendaNotif.agenda">
          Devedor: {{agendaNotif.agenda.iddevedor.Nome}} <br>
          CPF: {{agendaNotif.agenda.iddevedor.CnpjCpf}} <br>
          Data do agendamento: {{agendaNotif.agenda.data | moment("DD/MM/YYYY HH:mm")}} <br>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" @click.native="dialogNotif = false">Fechar</v-btn>
          <v-btn color="blue darken-1" @click.native="cobrarNotif(agendaNotif)">Cobrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Carrregando, Aguarde..
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </header>
</template>

<script>
import { mapMutations } from "vuex";
import store from "@/store";
import usuario from "@/services/usuario";
import empresaCtrl from "@/services/empresa";
import agendaCtrl from "@/services/agendas";

export default {
  name: "Header",
  data() {
    return {
      name: "Header",
      title: 'Vuetify.js',
      scrolled: false,
      dialogError: false,
      menu: false,
      user: {},
      search: "",
      empresa: {},
      dialogNotif: false,
      agendaNotif: {}
    };
  },
  // sockets : {
  //   connect: function(){
  //     console.log('socket connected');
  //   },
  //   notific: function(val){
  //     if (val.user1 == this.user._id || val.user2 == this.user._id) {
  //       this.$store.dispatch("SET_USUARIOS", this.user);
  //       var audio = new Audio('/static/img/guess-what.mp3');
  //       audio.play();
  //     }
  //   }
  // },
  async created () {
    this.menu = false;
  },
  async mounted() {
    const theme = localStorage.getItem("themeCache");
    if (theme) {
      if (theme == "true") {
        this.$vuetify.theme.dark = true;
      } else this.$vuetify.theme.dark = false;
    }
    if (store.getters.user) {
      this.$store.dispatch("SET_USUARIOS", this.user);
    }
  },
  
  watch: {
    '$route': async function () {
      if (store.getters.user) {
        this.user = await usuario.getUsuario(store.getters.user._id);
        this.empresa = await empresaCtrl.getId(store.getters.user.empresa);
        
        let agendaNotif = await agendaCtrl.getNotifUser(store.getters.user._id);
        if (agendaNotif && agendaNotif.length > 0) {
          this.dialogNotif = true;
          this.agendaNotif = agendaNotif[0];
        }
      }
    }
  },
  computed: {
    // Set your username thanks to your getter
    isLoggin() {
      return this.$store.getters.user ? true : false;
    },
    username() {
      return this.$store.getters["username"];
    },
    isDesconto () {
      return this.$store.getters.desconto;
    },
    loading () {
      return this.$store.getters.loading;
    },
    drawer () {
      return this.$store.getters.drawer;
    },
    usuarios () {
      return this.$store.getters.usuarios;
    },
    drawerRight () {
      return this.$store.getters.drawerRight;
    }
  },
  asyncComputed: {
    async isUser () {
      if (!this.$store.getters.user) {
        return false;
      } else {
        let res = await usuario.getUsuario(this.$store.getters.user._id);
        if (res != null && res.grand == "Funcionario") {
          return false;
        } else {
          return true;
        }
      }
    },
    async items () {
      let items = [];
      if (store.getters.user) {
        let res = await usuario.getUsuario(store.getters.user._id);
        if (res != null && res.acesso == "Devedor") {
          items = [
            { icon: "money", text: "Minhas Dividas", link: "minhas-dividas" },
          ];
        } else if (res != null && res.acesso == "Funcionario") {
          items = [
            { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
            { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Recebimento",
              children: [
                { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
              ]
            }
          ];
        } else if (res != null && res.acesso == "Financeiro") {
          items = [
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Configurações",
              children: [
                { icon: "business", text: "Clientes", link: "/clientes" },
                { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
                { icon: "money_off", text: "Dividas", link: "/dividas" },
                { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" },
              ]
            },
            {
                  icon: "keyboard_arrow_up",
                  "icon-alt": "keyboard_arrow_down",
                  text: "Movimentações",
                  children: [
                    { icon: "monetization_on", text: "Financeiro", link: "/financeiro" },
                    { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" },
                  ]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Recebimento",
              children: [
                { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
              ]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Relatório",
              children: [
                { icon: "bar_chart", text: "Dividas", link: "/rel-dividas" },
              ]
            },
            //{ icon: "bar_chart", text: "Fechamento", link: "/fechamento" },
          ];
        } else if (res != null && res.acesso == "Advogado") {
          items = [
            { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
            { icon: "money_off", text: "Dividas", link: "/dividas" }
          ];
        } else if (res != null && res.acesso == "Cadastradores") {
          items = [
            { icon: "business", text: "Clientes", link: "/clientes" },
            { icon: "people", text: "Devedores", link: "/devedores" },
            { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
            { icon: "money_off", text: "Dividas", link: "/dividas" }
          ];
        } else if (res != null && res.acesso == "AdminClientes") {
          items = [
            { icon: "dashboard", text: "Painel", link: "/painel" },
            { icon: "money_off", text: "Dividas", link: "/dividas" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Recebimento",
              children: [
                { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
              ]
            }
            //{ icon: "dashboard", text: "Fechamento", link: "/fechamento" },
          ];
        } else if (res != null && res.acesso == "Cliente") {
          items = [
            { icon: "dashboard", text: "Painel", link: "/painel" },
            { icon: "money_off", text: "Dividas", link: "/dividas" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Recebimento",
              children: [
                { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
              ]
            }
            //{ icon: "dashboard", text: "Fechamento", link: "/fechamento" },
          ];
        } else if (res != null && res.grand == "Geral") {
          items = [
                { icon: "dashboard", text: "Painel", link: "/painel" },
                
                {
                  icon: "keyboard_arrow_up",
                  "icon-alt": "keyboard_arrow_down",
                  text: "Configurações",
                  children: [
                    { icon: "perm_contact_calendar", text: "Usuários", link: "/usuarios"},
                    { icon: "business", text: "Empresas", link: "/empresas" },
                    { icon: "business", text: "Clientes", link: "/clientes" },
                    { icon: "people", text: "Devedores", link: "/devedores" },
                    { icon: "money_off", text: "Dividas", link: "/dividas" },
                  ]
                },
                {
                  icon: "keyboard_arrow_up",
                  "icon-alt": "keyboard_arrow_down",
                  text: "Movimentação",
                  children: [
                    { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
                    { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" },
                    { icon: "monetization_on", text: "Financeiro", link: "/financeiro" },
                    { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" },
                  ]
                },
                {
                  icon: "keyboard_arrow_up",
                  "icon-alt": "keyboard_arrow_down",
                  text: "Recebimento",
                  children: [
                    { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                    { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                    { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                    { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
                  ]
                },
                {
                  icon: "keyboard_arrow_up",
                  "icon-alt": "keyboard_arrow_down",
                  text: "Relatório",
                  children: [
                    { icon: "bar_chart", text: "Dividas", link: "/rel-dividas" },
                  ]
                },
                { icon: "dashboard", text: "Fechamento", link: "/fechamento" },
          ];
        } else {
          items = [
            { icon: "dashboard", text: "Painel", link: "/painel" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Configurações",
              children: [
                { icon: "perm_contact_calendar", text: "Usuários", link: "/usuarios"},
                { icon: "business", text: "Clientes", link: "/clientes" },
                { icon: "people", text: "Devedores", link: "/devedores" },
                { icon: "money_off", text: "Dividas", link: "/dividas" },
              ]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Movimentações",
              children: [
                { icon: "money", text: "Cobrança", link: "/funcionario/cobranca" },
                { icon: "schedule", text: "Agenda", link: "/funcionario/agenda" },
                { icon: "monetization_on", text: "Financeiro", link: "/financeiro" },
                { icon: "monetization_on", text: "Boleto BB", link: "/boletosbb" },
              ]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Recebimento",
              children: [
                { icon: "highlight", text: "Vigente", link: "/recebimentos/4" },
                { icon: "money", text: "Recebido", link: "/recebimentos/2" },
                { icon: "money_off", text: "Atraso", link: "/recebimentos/3" },
                { icon: "delete", text: "Cancelado", link: "/recebimentos/9" },
              ]
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Relatório",
              children: [
                { icon: "bar_chart", text: "Dividas", link: "/rel-dividas" },
              ]
            },
            { icon: "dashboard", text: "Fechamento", link: "/fechamento" },
          ];
        }
      }
      return items;
    },
    async menus () {
      let menus = [
        {
          icon: 'home',
          title: 'Registrar',
          to: '/signup'
        },
        {
          icon: 'label',
          title: 'Entrar',
          to: '/signin'
        }]
      if (this.$store.getters.user) {
        menus = [
          
          {
            icon: 'label',
            title: 'Logout',
            to: '/logout'
          }
        ]
      }
      return menus
    }
  },
  methods: {
    scrollFix: function(hashbang) {
      if (hashbang) {
        location.href = hashbang;
      } else {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      }

    },
    filterItems: function(presets) {
        var app = this;
        if (app.search && app.search.length > 0) {
          return presets.filter(function(preset) {
              let regex = new RegExp('(' + app.search + ')', 'i');
              if (preset.text.match(regex)) {
                return preset.text.match(regex);
              } else {
                let retorno = []
                if (preset.children && preset.children.length > 0) {
                  
                  preset.children.forEach(element => {
                    if (element.text.match(regex)) {
                      retorno.push(element);
                    }
                  });
                  return retorno;
                }
              }
          })
        } else {
          return presets;
        }
    },
    getPath (usuario) {
      if (this.user) {
        let uid1 = this.user._id;
        let uid2 = usuario._id;
        let path = uid1 < uid2 ? uid1 + '/' + uid2 : uid2 + '/' + uid1;
        return '/chat/'+path;
      }
    },
    home () {
      this.$router.push('/')
    },
    async cobrarNotif (item) {
      this.dialogNotif = false;
      item.verificou = true;
      await agendaCtrl.saveNotific(item);
      this.$router.push('/funcionario/cobranca/'+item.agenda.iddevedor._id);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue